import { render, staticRenderFns } from "./nibrs_review_form.vue?vue&type=template&id=3854faca&scoped=true&"
import script from "./nibrs_review_form.vue?vue&type=script&lang=js&"
export * from "./nibrs_review_form.vue?vue&type=script&lang=js&"
import style0 from "./nibrs_review_form.vue?vue&type=style&index=0&id=3854faca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3854faca",
  null
  
)

export default component.exports